import {
  registerDecorator,
  ValidationOptions,
  ValidationArguments,
} from 'class-validator';
import { DateTime } from 'luxon';

export function isDateTime(value: any, format: string | undefined): boolean {
  if (typeof value !== 'string') return false;
  const parsed =
    format === undefined
      ? DateTime.fromISO(value)
      : DateTime.fromFormat(value, format);
  return parsed.isValid;
}

export function IsDateTime(
  format: string,
  validationOptions?: ValidationOptions,
) {
  return function (object: object, propertyName: string) {
    registerDecorator({
      name: 'isDateTime',
      target: object.constructor,
      propertyName: propertyName,
      constraints: [format],
      options: validationOptions,
      validator: {
        validate(value: any, args: ValidationArguments) {
          const [format] = args.constraints as [string | undefined];
          return isDateTime(value, format);
        },
        defaultMessage(args: ValidationArguments) {
          const [format] = args.constraints as [string | undefined];
          return format === undefined
            ? `${args.property} must be a valid ISO date-time string`
            : `${args.property} must be a valid date-time string in format ${format}`;
        },
      },
    });
  };
}
